<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item)"
    class="nav-item has-sub"
    :class="{
      'open': isOpen,
      'disabled': item.disabled,
      'sidebar-group-active': isParentActive,
      'super-active active': isActive
    }"
  >
    <b-link
      class="d-flex align-items-center"
      v-bind="linkProps"
      @click="shouldOpen(! isOpen)"
    >
      <!-- <component :is="resolveVerticalNavIconComponent(item.icon)" /> -->
    <vector 
        :data-name="item.icon"
        :data-width='item.width ? item.width : "16"'
        :data-height='item.height ? item.height : "16"'
        :data-class="item.class ? item.class : ''" 
        :data-style="['vertical-align: unset;margin-right: .6rem;position: relative; top: 1px;', item.style ? item.style : ''].join('')"
    ></vector>
      <!-- <vector :data-name="item.icon" data-width='16' data-height='16' data-style="vertical-align: unset;margin-right: .6rem;" style="position: relative; top: 1px;"></vector> -->

      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>

    <b-collapse
      v-model="isOpen"
      class="menu-content"
      tag="ul"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from 'bootstrap-vue';
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent, resolveVerticalNavIconComponent } from '@core/layouts/utils';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { useUtils as useAclUtils } from '@core/libs/acl';
// import { ref } from '@vue/composition-api';
import VerticalNavMenuHeader from '../vertical-nav-menu-header';
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue';

// Composition Function
import useVerticalNavMenuGroup from './useVerticalNavMenuGroup';
import mixinVerticalNavMenuGroup from './mixinVerticalNavMenuGroup';
import useVerticalNavMenuLink from '../vertical-nav-menu-link/useVerticalNavMenuLink';
import mixinVerticalNavMenuLink from '../vertical-nav-menu-link/mixinVerticalNavMenuLink';

export default {
    name: 'VerticalNavMenuGroup',
    components: {
        VerticalNavMenuHeader,
        VerticalNavMenuLink,
        BLink,
        BBadge,
        BCollapse,
    },
    mixins: [mixinVerticalNavMenuGroup, mixinVerticalNavMenuLink],
    props: {
        item: {
            type: Object,
            required: true,
        },
    },

    setup(props, { root }) {
        const { updateIsActive, linkProps, isActive } = useVerticalNavMenuLink(props.item);

        const {
            isOpen,
            isParentActive,
            updateIsParentActive,
            updateGroupOpen,
        } = useVerticalNavMenuGroup(props.item);

        const { t } = useI18nUtils();
        const { canViewVerticalNavMenuGroup } = useAclUtils();

        function shouldOpen(condition)
        {
            root.$nextTick(() => {
                updateGroupOpen(condition);
            });
        }
        
        return {
            resolveNavItemComponent,
            resolveVerticalNavIconComponent,
            isOpen,
            isActive,
            updateGroupOpen,
            updateIsActive,
            linkProps,
            isParentActive,
            updateIsParentActive,


            // ACL
            canViewVerticalNavMenuGroup,

            // i18n
            t,

            shouldOpen,
            // isGroupActive
        };
    },
};
</script>

<style>
.super-active > a
{
    background: linear-gradient(118deg, #4267b2, rgba(66, 103, 178, 0.7)) !important;
    color: white !important;
}
</style>
